import { render } from "./index.vue?vue&type=template&id=acc2b9a0"
import script from "./manufacturing.js?vue&type=script&lang=js&external"
export * from "./manufacturing.js?vue&type=script&lang=js&external"

import "./manufacturing.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__